import React from 'react';
import axios from 'axios';
import { Button, Radio, message } from 'antd';
import queryString from 'query-string';

import history from '../../commons/history';
import GraphView from './GraphView';
import localStorage from '../../utils/localStorage';
import { translation } from '../Adapter/TranslationAdapter.js';
import { NoRecordComponent } from '../Dashboard/ChartComponents/Utils';
import ViewDashboard from '../Dashboard/DashboardComponents/Dashboard';
import { BackwardOutlined } from '@ant-design/icons';
import { API_DEVICE, FFT } from '../../commons/api.js';

class GraphViewComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trendData: {
        Device: 'CV-121',
        TimeStamp: '2022-01-06 14:07:59',
        FileName: '20220106173759.cna',
        FFTOutPut: {},
        xRanges: {
          gridIndex: 0,
          min: '0.000001',
          max: '0.058540'
        },
        yRanges: {
          gridIndex: 1,
          min: '0.000002',
          max: '0.113124'
        },
        zRanges: {
          gridIndex: 2,
          min: '0.000001',
          max: '0.059487'
        }
      },
      type: 'graph',
      deviceList: [],
      language: props.language || 'English'
    };
  }

  componentDidMount() {
    // /rubus/FFTLink?filename=20220106173759.cna&device=CV-121
    let params = queryString.parse(this.props.history.location.search);
    this.getDeviceList();
    this.graphView(params);
  }

  getDeviceList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then((res) => {
        let deviceList = res.data;
        this.setState({ deviceList });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  graphView = (data) => {
    let siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'POST',
      url: `${FFT.Show}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        device: data.device,
        filename: [data.filename]
      }
    };
    axios(headers)
      .then((res) => {
        this.setState({
          trendData: res.data && res.data[0] ? res.data[0] : {},
          device: data.device
        });
      })
      .catch((error) => {
        if (error.response.status === 400 || error.response.status === 500) {
          message.info(error.response.data.message);
        }
      });
  };

  handleChange = (e) => {
    const type = e.target.value;
    this.setState({ type });
  };

  render() {
    let { trendData, device, deviceList, type, translationCache } = this.state;

    let filteredDevice = deviceList.filter((deviceObject) => {
      return deviceObject.AliasCode.toString() === device;
    });
    return (
      <React.Fragment>
        <div
          style={{
            fontSize: 'bold',
            padding: '20px',
            background: 'white',
            minHeight: window.innerHeight - 120
          }}
        >
          <div
            style={{
              fontWeight: 'bold',
              color: 'black',
              fontSize: '17px',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            {filteredDevice &&
            Array.isArray(filteredDevice) &&
            filteredDevice[0] &&
            filteredDevice[0].Name
              ? `${filteredDevice[0].DeviceCode}${
                  filteredDevice[0].DeviceDescription
                    ? `-${translation(filteredDevice[0].DeviceDescription, translationCache)}`
                    : ''
                }  `
              : device}
          </div>
          <Button
            type=""
            style={{ border: '2px solid #40a9ff', color: '#40a9ff' }}
            onClick={() => {
              history.push({
                pathname: `/rubus/FFT`,
                state: device ? device : ''
              });
            }}
          >
            <BackwardOutlined />
            {translationCache && translationCache['FFT'] && translationCache['FFT']
              ? translationCache['FFT']
              : 'FFT'}
          </Button>
          <Radio.Group onChange={this.handleChange} value={type} style={{ float: 'right' }}>
            <Radio.Button value="graph">FFT Graph</Radio.Button>
            <Radio.Button value="summary">Summary</Radio.Button>
          </Radio.Group>

          {trendData && type === 'graph' ? (
            <div>
              {trendData && Object.keys(trendData).length !== 0 ? (
                <GraphView
                  panelData={{
                    graph: 'trends',
                    trendData
                  }}
                />
              ) : (
                <NoRecordComponent />
              )}
            </div>
          ) : (
            <div>
              <ViewDashboard match={{ params: { name: 'FFT', deviceId: device } }} />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
export default GraphViewComponent;
